import React, { useEffect, useMemo, useState } from 'react';
import { INavStyles, INavLinkGroup, INavLink } from '@fluentui/react/lib/Nav';
import { BwjNav } from '../../framework/components/bwj-nav';
import { useEventNotification } from '../../framework/services/event-notification';
import { AppMenuEvents } from '../../events/app-menu';
import { getTheme, IStyle, mergeStyleSets, PanelType } from '@fluentui/react';
import { BwjSidePanel } from '../../framework/components/bwj-side-panel';
import { where } from '../../framework/utils/collection';
/*@begin-app-target*/import { getAppRoutesArray } from '../../app-volunteer/app-routes';/*@end-app-target*/
import { IAppRoute } from '../../entities/app-route';
interface IAppSideNavProps {
  title: string;
  invokeShowMobileNav: {} | undefined;
  showDesktopNav: boolean;
}

const getStyleClasses = () => {
  const desktopMenu: IStyle = {
    display: 'none',
    width: 220,
    height: '100%',

    '& > .ms-FocusZone': {
      height: '100%',
    },

    '@media(min-width: 501px)': {
      display: 'block',
    },
  };

  return mergeStyleSets({
    desktopMenu,
  });
};

const getNavStyles = (): Partial<INavStyles> => {
  const theme = getTheme();
  return {
    root: {
      width: '100%',
      height: '100%',
      boxSizing: 'border-box',
      border: 'none',
      backgroundColor: theme.palette.neutralLighter,
      overflowY: 'auto',
    },
    // these link styles override the default truncation behavior
    link: {
      lineHeight: 'inherit',
    },
  };
};

const getLinkGroups = () => {
  const linkable = where(getAppRoutesArray(), r => r.topLevel && !!r.sideMenuLabel);

  const links: INavLink[] = linkable.map(r => {
    const route = r as IAppRoute<() => string>;
    return {
      name: route.sideMenuLabel!,
      url: route.url(),
      key: route.key,
      icon: route.icon,
    };
  });

  const navLinkGroups: INavLinkGroup[] = [{ links }];
  return navLinkGroups;
}

const subscriberId = 'Component.AppSideNav';

export const AppSideNav: React.FunctionComponent<IAppSideNavProps> = (props) => {
  const { invokeShowMobileNav } = props;
  const [selectedKey, setSelectedKey] = useState('none');
  const [showMobileNav, setShowMobileNav] = useState(false);
  const styles = getStyleClasses();
  const navStyles = getNavStyles();
  const navLinkGroups = useMemo(getLinkGroups, []);

  useEventNotification((key: string) => setSelectedKey(key), [], AppMenuEvents.ChangeSelectedLink, subscriberId);

  useEffect(() => {
    setShowMobileNav(invokeShowMobileNav !== undefined);
  }, [invokeShowMobileNav]);

  return (
    <>
      <BwjSidePanel
        showPanel={showMobileNav}
        title={props.title}
        panelType={PanelType.smallFixedNear}
        onDismiss={() => setShowMobileNav(false)}
        closeButtonAriaLabel={'Close main menu'}
      >
        <BwjNav
          selectedKey={selectedKey}
          ariaLabel={'Main menu'}
          styles={navStyles}
          groups={navLinkGroups}
          onLinkClick={() => setShowMobileNav(false)}
        />
      </BwjSidePanel>
      {props.showDesktopNav &&
      <div className={styles.desktopMenu}>
        <BwjNav
          selectedKey={selectedKey}
          ariaLabel={'Main menu'}
          styles={navStyles}
          groups={navLinkGroups}
        />
      </div>}
    </>
  );
};
